import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

// import InstagramFeed from "./instagram-feed";

import Instagram from "../css/assets/instagram.inline.svg";
import Facebook from "../css/assets/facebook.inline.svg";

import "../css/footer.css";

export default function Footer() {
  return (
    <div className="footer-instagram-container">
      {/* <InstagramFeed /> */}
      <footer className="footer-container">
        <div className="footer-content">
          <div className="footer-logo">
            <Link to="/">
              <StaticImage
                src="../css/assets/logo.png"
                alt="Amalgam Homes Logo Gold"
                placeholder="blurred"
                layout="fixed"
                width={160}
                className="footer-logo"
                // height={220}
              />
            </Link>
          </div>
          <div className="footer-links">
            <div className="footer-links-col">
              <span className="footer-links-col-title">Booking</span>
              <a href="https://amalgamhomesparos.reserve-online.net" target="_blank" rel="noopener noreferrer">Reserve Paros</a>
              <a href="https://dafnivilla.reserve-online.net" target="_blank" rel="noopener noreferrer">Reserve Mykonos</a>
              <Link to="/inquiries">Reserve Naxos</Link>
              <Link to="/inquiries">Inquiries</Link>
            </div>
            <div className="footer-links-col">
              <span className="footer-links-col-title">Destinations</span>
              <Link to="/islands/paros">Paros</Link>
              <Link to="/islands/mykonos">Mykonos</Link>
              <Link to="/islands/naxos">Naxos</Link>
              <Link to="/islands/tinos">Tinos</Link>
            </div>
            <div className="footer-links-col">
              <span className="footer-links-col-title">Other</span>
              <Link to="/#about">About</Link>
              <Link to="/our-places">Our Places</Link>
              <Link to="/blog">Blog</Link>
              <Link to="/bespoke-services">Bespoke Services</Link>
              <Link to="/frequently-asked-questions">FAQ</Link>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </div>
            <div className="footer-links-col hidden">
              <div className="social-icons-footer">
                <a
                  href="https://www.instagram.com/amalgamhomes"
                  aria-label="Instagram Link Amalgam Homes"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Instagram className="instagram" />
                </a>
                <a
                  href="https://www.facebook.com/AmalgamHomes/"
                  aria-label="Facebook Link Amalgam Homes"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Facebook className="facebook" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}